var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRESENTMENT_PRICE_FRAGMENT = exports.PRICE_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.PRICE_FRAGMENT = (0, graphql_tag_1.default) `
  fragment PriceFragment on ProductVariant {
    priceV2 {
      amount
      currencyCode
    }
    compareAtPriceV2 {
      amount
      currencyCode
    }
  }
`;
exports.PRESENTMENT_PRICE_FRAGMENT = (0, graphql_tag_1.default) `
  fragment PresentmentPriceFragment on ProductVariantPricePair {
    price {
      amount
      currencyCode
    }
    compareAtPrice {
      amount
      currencyCode
    }
  }
`;
//# sourceMappingURL=priceFragment.js.map